{
  "schema_version": 1,
  "source": "design/reference/Task-Panes-latest.html (logic.js THEMES)",
  "order": [
    "dark",
    "midnight",
    "mocha",
    "forest",
    "wine",
    "london",
    "light",
    "paper",
    "sage",
    "rose"
  ],
  "names": {
    "dark": "Dark",
    "midnight": "Midnight",
    "mocha": "Mocha",
    "forest": "Forest",
    "wine": "Wine",
    "light": "Light",
    "paper": "Paper",
    "sage": "Sage",
    "rose": "Rose",
    "london": "London"
  },
  "themes": {
    "dark": {
      "--n1e1f22": "#1e1f22",
      "--ne7e7ea": "#f2f2f3",
      "--n7ea6f4": "#7ea6f4",
      "--na9c3f8": "#a9c3f8",
      "--n6d6e74": "#8a8b90",
      "--n34353a": "#34353a",
      "--n8a8b91": "#afb0b4",
      "--n2e2f33": "#2e2f33",
      "--n45464b": "#45464b",
      "--n76777d": "#a0a1a5",
      "--n2d2e32": "#2d2e32",
      "--n26272b": "#26272b",
      "--n2b2c30": "#2b2c30",
      "--n38393e": "#38393e",
      "--n3a3b40": "#3a3b40",
      "--n9c9da3": "#bdbdc1",
      "--n8f9096": "#b5b5b9",
      "--n5f6066": "#797a7f",
      "--n5d5e64": "#727378",
      "--nc9cacf": "#d9dadd",
      "--n333438": "#333438",
      "--n2c2d32": "#2c2d32",
      "--n2a2b2f": "#2a2b2f",
      "--n4a4b50": "#4a4b50",
      "--scheme": "dark"
    },
    "midnight": {
      "--n1e1f22": "#11151f",
      "--ne7e7ea": "#f1f3f8",
      "--n7ea6f4": "#8fb3ff",
      "--na9c3f8": "#b9ceff",
      "--n6d6e74": "#7f889c",
      "--n34353a": "#252c3d",
      "--n8a8b91": "#adb4c5",
      "--n2e2f33": "#1f2535",
      "--n45464b": "#39425a",
      "--n76777d": "#99a1b3",
      "--n2d2e32": "#1d2332",
      "--n26272b": "#171c29",
      "--n2b2c30": "#1a2030",
      "--n38393e": "#2a3246",
      "--n3a3b40": "#2d3549",
      "--n9c9da3": "#bac1d0",
      "--n8f9096": "#afb6c6",
      "--n5f6066": "#727a91",
      "--n5d5e64": "#5e677d",
      "--nc9cacf": "#d5dae5",
      "--n333438": "#222939",
      "--n2c2d32": "#1b2131",
      "--n2a2b2f": "#1c2231",
      "--n4a4b50": "#3d4763",
      "--scheme": "dark"
    },
    "mocha": {
      "--n1e1f22": "#1f1a17",
      "--ne7e7ea": "#f5f0ec",
      "--n7ea6f4": "#d9a477",
      "--na9c3f8": "#e8c3a2",
      "--n6d6e74": "#93877e",
      "--n34353a": "#3a312b",
      "--n8a8b91": "#bbafa6",
      "--n2e2f33": "#342c27",
      "--n45464b": "#4d423a",
      "--n76777d": "#aba098",
      "--n2d2e32": "#322a25",
      "--n26272b": "#28211d",
      "--n2b2c30": "#2c2420",
      "--n38393e": "#3e352f",
      "--n3a3b40": "#41372f",
      "--n9c9da3": "#c5bbb2",
      "--n8f9096": "#bdb1a8",
      "--n5f6066": "#81756c",
      "--n5d5e64": "#70655c",
      "--nc9cacf": "#e1d7cf",
      "--n333438": "#372e29",
      "--n2c2d32": "#2e2622",
      "--n2a2b2f": "#2d2621",
      "--n4a4b50": "#524640",
      "--scheme": "dark"
    },
    "forest": {
      "--n1e1f22": "#121a17",
      "--ne7e7ea": "#eff4f1",
      "--n7ea6f4": "#6fcf9b",
      "--na9c3f8": "#a3e2bf",
      "--n6d6e74": "#7c8c85",
      "--n34353a": "#22312b",
      "--n8a8b91": "#acbab2",
      "--n2e2f33": "#1d2a25",
      "--n45464b": "#33463e",
      "--n76777d": "#9ba9a2",
      "--n2d2e32": "#1c2823",
      "--n26272b": "#18221e",
      "--n2b2c30": "#1a2520",
      "--n38393e": "#28382f",
      "--n3a3b40": "#2a3a33",
      "--n9c9da3": "#b7c4bc",
      "--n8f9096": "#aebcb4",
      "--n5f6066": "#6e7e74",
      "--n5d5e64": "#5e6d65",
      "--nc9cacf": "#d3ded7",
      "--n333438": "#1f2c27",
      "--n2c2d32": "#1b2621",
      "--n2a2b2f": "#1c2823",
      "--n4a4b50": "#3a4d44",
      "--scheme": "dark"
    },
    "wine": {
      "--n1e1f22": "#1d1517",
      "--ne7e7ea": "#f7f0f1",
      "--n7ea6f4": "#e07a98",
      "--na9c3f8": "#f2aec2",
      "--n6d6e74": "#8d7b7f",
      "--n34353a": "#33252a",
      "--n8a8b91": "#c1b1b5",
      "--n2e2f33": "#2b1f23",
      "--n45464b": "#4a3639",
      "--n76777d": "#af9ea1",
      "--n2d2e32": "#2a1e22",
      "--n26272b": "#251b1e",
      "--n2b2c30": "#281d21",
      "--n38393e": "#3a2a2f",
      "--n3a3b40": "#3d2c31",
      "--n9c9da3": "#ccbcc0",
      "--n8f9096": "#c3b3b7",
      "--n5f6066": "#7a696d",
      "--n5d5e64": "#6b5a5e",
      "--nc9cacf": "#e7dadd",
      "--n333438": "#2e2226",
      "--n2c2d32": "#291e21",
      "--n2a2b2f": "#2a1e22",
      "--n4a4b50": "#56404a",
      "--scheme": "dark"
    },
    "light": {
      "--n1e1f22": "#f7f7f5",
      "--ne7e7ea": "#141517",
      "--n7ea6f4": "#2f64d6",
      "--na9c3f8": "#1d4bb0",
      "--n6d6e74": "#848589",
      "--n34353a": "#e6e6e8",
      "--n8a8b91": "#4e4f53",
      "--n2e2f33": "#ececee",
      "--n45464b": "#cfd0d4",
      "--n76777d": "#626368",
      "--n2d2e32": "#e4e4e6",
      "--n26272b": "#ffffff",
      "--n2b2c30": "#ffffff",
      "--n38393e": "#e3e3e6",
      "--n3a3b40": "#dcdce0",
      "--n9c9da3": "#494a4f",
      "--n8f9096": "#4c4d51",
      "--n5f6066": "#898a8f",
      "--n5d5e64": "#abacaf",
      "--nc9cacf": "#2b2c30",
      "--n333438": "#eeeef0",
      "--n2c2d32": "#ffffff",
      "--n2a2b2f": "#ececee",
      "--n4a4b50": "#55565c",
      "--scheme": "light"
    },
    "paper": {
      "--n1e1f22": "#f4efe6",
      "--ne7e7ea": "#1c1915",
      "--n7ea6f4": "#9a5b2e",
      "--na9c3f8": "#7a431c",
      "--n6d6e74": "#928978",
      "--n34353a": "#e8dfd0",
      "--n8a8b91": "#5a5247",
      "--n2e2f33": "#ebe3d6",
      "--n45464b": "#d8ccb8",
      "--n76777d": "#6f675a",
      "--n2d2e32": "#e3d9c8",
      "--n26272b": "#fbf8f2",
      "--n2b2c30": "#fbf8f2",
      "--n38393e": "#e6dccb",
      "--n3a3b40": "#dcd1bd",
      "--n9c9da3": "#564e44",
      "--n8f9096": "#585045",
      "--n5f6066": "#988e7d",
      "--n5d5e64": "#b3a894",
      "--nc9cacf": "#383229",
      "--n333438": "#ede5d8",
      "--n2c2d32": "#fbf8f2",
      "--n2a2b2f": "#ebe2d3",
      "--n4a4b50": "#5c5347",
      "--scheme": "light"
    },
    "sage": {
      "--n1e1f22": "#eef2ec",
      "--ne7e7ea": "#141b16",
      "--n7ea6f4": "#2f7a52",
      "--na9c3f8": "#1e5c3c",
      "--n6d6e74": "#808d81",
      "--n34353a": "#dfe7dc",
      "--n8a8b91": "#48554c",
      "--n2e2f33": "#e3eadf",
      "--n45464b": "#c7d3c5",
      "--n76777d": "#5e6a63",
      "--n2d2e32": "#dbe4d8",
      "--n26272b": "#f8faf6",
      "--n2b2c30": "#f8faf6",
      "--n38393e": "#d9e2d6",
      "--n3a3b40": "#d0dbcd",
      "--n9c9da3": "#445048",
      "--n8f9096": "#47534a",
      "--n5f6066": "#88958a",
      "--n5d5e64": "#a4b2a6",
      "--nc9cacf": "#2a352d",
      "--n333438": "#e6ece3",
      "--n2c2d32": "#f8faf6",
      "--n2a2b2f": "#e4ebe1",
      "--n4a4b50": "#4e5c52",
      "--scheme": "light"
    },
    "rose": {
      "--n1e1f22": "#f7efef",
      "--ne7e7ea": "#1d1617",
      "--n7ea6f4": "#b8486a",
      "--na9c3f8": "#8c2f4d",
      "--n6d6e74": "#a29093",
      "--n34353a": "#ecdfe0",
      "--n8a8b91": "#5c4c4f",
      "--n2e2f33": "#f0e5e6",
      "--n45464b": "#dccbcd",
      "--n76777d": "#6c5b5e",
      "--n2d2e32": "#ebdcdd",
      "--n26272b": "#fdf8f8",
      "--n2b2c30": "#fdf8f8",
      "--n38393e": "#e8d9da",
      "--n3a3b40": "#e1d0d2",
      "--n9c9da3": "#54454a",
      "--n8f9096": "#5a4a4d",
      "--n5f6066": "#a49194",
      "--n5d5e64": "#bbaaad",
      "--nc9cacf": "#382c2e",
      "--n333438": "#f2e8e9",
      "--n2c2d32": "#fdf8f8",
      "--n2a2b2f": "#f0e4e5",
      "--n4a4b50": "#5e4b50",
      "--scheme": "light"
    },
    "london": {
      "--n1e1f22": "#0c1433",
      "--ne7e7ea": "#f8f6ef",
      "--n7ea6f4": "#e32017",
      "--na9c3f8": "#f2c14e",
      "--n6d6e74": "#7e87a8",
      "--n34353a": "#1f2b5c",
      "--n8a8b91": "#c1c6d9",
      "--n2e2f33": "#18234e",
      "--n45464b": "#33407a",
      "--n76777d": "#a8afc7",
      "--n2d2e32": "#172149",
      "--n26272b": "#111a3f",
      "--n2b2c30": "#141e46",
      "--n38393e": "#263369",
      "--n3a3b40": "#2a376f",
      "--n9c9da3": "#ced2e1",
      "--n8f9096": "#c3c8d9",
      "--n5f6066": "#69739a",
      "--n5d5e64": "#59628a",
      "--nc9cacf": "#e7e3d6",
      "--n333438": "#1a2552",
      "--n2c2d32": "#152047",
      "--n2a2b2f": "#172149",
      "--n4a4b50": "#46528a",
      "--scheme": "dark"
    }
  },
  "accent": {
    "default": "#5b8def",
    "options": [
      "#5b8def",
      "#4fb286",
      "#d9895b",
      "#a678e0",
      "#d46a8c"
    ]
  },
  "semantic": {
    "danger": "#e2837a",
    "warning": "#e5b567",
    "success": "#4fb286"
  },
  "avatarColors": [
    "#5b8def",
    "#d9895b",
    "#a678e0",
    "#4fb286",
    "#d46a8c",
    "#c9a64a"
  ],
  "density": {
    "compact": {
      "rowPy": "2px",
      "listGap": "10px",
      "title": "14px"
    },
    "cozy": {
      "rowPy": "5px",
      "listGap": "18px",
      "title": "15px"
    },
    "airy": {
      "rowPy": "9px",
      "listGap": "30px",
      "title": "16px"
    }
  },
  "shape": {
    "sharp": {
      "round": 0.3,
      "pill": "5px"
    },
    "soft": {
      "round": 1,
      "pill": "999px"
    },
    "round": {
      "round": 1.7,
      "pill": "999px"
    }
  },
  "typeface": {
    "sans": "'Vazirmatn', system-ui, sans-serif",
    "serif": "'Newsreader', 'Vazirmatn', Georgia, serif",
    "mono": "'JetBrains Mono', 'Vazirmatn', ui-monospace, monospace"
  },
  "motion": {
    "tick": "260ms ease-out",
    "leave": "420ms ease-in",
    "leaveHoldMs": 900,
    "paneIn": "320ms cubic-bezier(.2,.8,.2,1)",
    "paneGlow": "1500ms ease-out",
    "undoMs": 5000,
    "toast": "200ms ease-out",
    "flashMs": 3500,
    "sheet": "260ms cubic-bezier(.2,.8,.2,1)",
    "pop": "140ms ease-out",
    "arrive": "320ms ease-out",
    "open": "220ms cubic-bezier(.2,.8,.2,1)",
    "paneWidth": "200ms ease",
    "header": "180ms ease",
    "swipe": "230ms cubic-bezier(.2,.8,.2,1)"
  },
  "layout": {
    "projectsPaneW": 260,
    "projectsPaneMin": 180,
    "paneW": 400,
    "paneMin": 280,
    "paneMax": 900,
    "collapsedW": 44,
    "stripW": 45,
    "mobileBreakpoint": 600,
    "mobilePeek": 28
  },
  "notes": {
    "contrast": "Design v8 (TaskCool 8.0): every theme's text is boosted for contrast at load — the primary text (--ne7e7ea) is mixed 45% (dark themes) / 35% (light themes) toward white / black, then secondary tokens are mixed toward that text colour by contrastBoost.factors. The values in `themes` are the final, boosted colours (reference raw values + this rule); the High contrast production theme was removed in 8.0 (not in the design)."
  },
  "contrastBoost": {
    "text": {
      "dark": {
        "toward": "#ffffff",
        "amount": 0.45
      },
      "light": {
        "toward": "#000000",
        "amount": 0.35
      }
    },
    "factors": {
      "--nc9cacf": 0.4,
      "--n9c9da3": 0.38,
      "--n8f9096": 0.38,
      "--n8a8b91": 0.36,
      "--n76777d": 0.34,
      "--n6d6e74": 0.22,
      "--n5f6066": 0.18,
      "--n5d5e64": 0.14
    }
  },
  "themeAccent": {
    "london": "#e32017"
  }
}
